import {
  IHttpApi,
  mergeBaseUri,
  mergePaths,
  transformObjectToQuery,
  IHTTPRequestConfig,
  IHTTPCompletedResponse,
} from '@cian/http-api';

import { IUnsubscribeFromCommentsRequest, IUnsubscribeFromCommentsConfig, TResponses } from './types';

const defaultConfig: Required<IUnsubscribeFromCommentsConfig> = {
  pathApi: '/v1/unsubscribe-comment',
  browserUrl: 'http://www.master.dev3.cian.ru/content-api',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultRequest: IHTTPRequestConfig<any> = {
  uri: {
    host: '',
    path: '',
  },
  method: 'POST',
  requestType: 'formData',
  body: '',
  withCredentials: true,
  headers: [['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8']],
};

function createUnsubscribeFromCommentsRequest({
  bodyParameters,
  config,
}: Pick<IUnsubscribeFromCommentsOptions, 'bodyParameters' | 'config'>): IHTTPRequestConfig<any> {
  const { pathApi, browserUrl } = { ...defaultConfig, ...config };

  return {
    ...defaultRequest,
    uri: mergeBaseUri(browserUrl, {
      path: (path: string) => mergePaths(path, pathApi),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: transformObjectToQuery(bodyParameters as any).unwrap() as any,
  };
}

export interface IUnsubscribeFromCommentsOptions {
  httpApi: IHttpApi;
  bodyParameters: IUnsubscribeFromCommentsRequest;
  config?: IUnsubscribeFromCommentsConfig;
}

async function fetchUnsubscribeFromComments({
  httpApi,
  bodyParameters,
  config,
}: IUnsubscribeFromCommentsOptions): Promise<IHTTPCompletedResponse<TResponses>> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return httpApi.httpRequest(createUnsubscribeFromCommentsRequest({ bodyParameters, config })) as any;
}

export { defaultConfig, createUnsubscribeFromCommentsRequest, fetchUnsubscribeFromComments };
